import { Component } from '@angular/core';
import { UilabMatTabsModule } from '@uilab/ng-mat-components';
import { CodeExampleComponent } from 'src/app/shared/components/code-example/code-example.component';
import { CodeExampleHeaderComponent } from 'src/app/shared/components/code-example/code-example-header.component';
import { COMPONENT_EXAMPLES_CONSTANTS } from '../component-examples.constants';

interface TabsExample {
    readonly variant: 'basic';
    readonly label: string;
    readonly description: string;
    readonly htmlSnippet: string;
}

@Component({
    selector: 'avd-tabs-examples',
    templateUrl: './tabs-examples.component.html',
    styleUrls: ['./tabs-examples.component.scss'],
    imports: [
        CodeExampleHeaderComponent,
        CodeExampleComponent,
        UilabMatTabsModule,
    ],
})
export class TabsExamplesComponent {
    readonly packageName = COMPONENT_EXAMPLES_CONSTANTS.PACKAGE_NAME;
    readonly getStartedLink = COMPONENT_EXAMPLES_CONSTANTS.GET_STARTED_LINK;
    readonly storybookLink =
        'https://calm-mushroom-0d2458d1e.2.azurestaticapps.net/?path=/docs/components-tabs--docs';
    readonly repoLink =
        'https://dev.azure.com/AVEVA-VSTS/UX/_git/uilab-base?version=GBfeat/angular-material-components&path=/projects/components/src/lib/tabs';

    readonly examples: readonly TabsExample[] = [
        {
            variant: 'basic',
            label: 'Basic Tabs',
            description:
                'Use tabs to organize related content into sections that users can switch between quickly.',
            htmlSnippet: `<uilab-mat-tab-group>
  <uilab-mat-tab label="Overview">
    <p>Overview content</p>
  </uilab-mat-tab>
  <uilab-mat-tab label="Details">
    <p>Details content</p>
  </uilab-mat-tab>
    <uilab-mat-tab label="Usage">
        <p>Usage content</p>
    </uilab-mat-tab>
    <uilab-mat-tab label="API">
        <p>API content</p>
    </uilab-mat-tab>
    <uilab-mat-tab label="Examples">
        <p>Examples content</p>
    </uilab-mat-tab>
</uilab-mat-tab-group>`,
        },
    ];
}
